<template>
    <blog-posts-find
        :post="$route.params.post"
        :preloaded="preloaded('post', true, 'data.slug')"
        :find-on-created="!preloaded('post', true, 'data.slug')"
        @success="onSuccess"
    >
        <div
            slot-scope="{
                data: post,
                error,
                is_loading,
                has_loaded,
                find
            }"
            class="container max-w-3xl pt-6 mx-auto md:pt-12"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <div class="max-w-md mx-auto mb-12 md:mb-24">
                    <div
                        class="mb-6 bg-cover rounded aspect-ratio-16/9"
                        :style="`background-image: url(${post.featured_image})`"
                    />

                    <h1 class="mb-6 text-3xl font-semibold font-noto-sans xs:text-4xl md:text-5xl text-grey-darkest">{{ post.title }}</h1>

                    <div
                        v-html="post.content"
                        class="blog-post-content"
                    />
                </div>
            </template>
        </div>
    </blog-posts-find>
</template>

<script>
    import _ from 'lodash'
    import HeadMixin from '../../../mixins/head'
    import PreloadedMixin from '../../../mixins/preloaded'
    import BlogPostsFind from '../../../components/blog-posts-find'

    export default {
        mixins: [
            HeadMixin,
            PreloadedMixin
        ],
        components: {
            BlogPostsFind
        },
        data () {
            return {
                store: {
                    post: _.get(this.preloaded('post', true, 'data.slug'), 'data')
                }
            }
        },
        methods: {
            head () {
                return {
                    title: [
                        _.get(this.store.post, 'title', '...'),
                        'Property blog'
                    ],
                    description: _.get(this.store.post, 'excerpt', '...'),
                    meta: [
                        {
                            property: 'og:image',
                            content: _.get(this.store.post, 'featured_image')
                        },
                        {
                            name: 'twitter:image',
                            content: _.get(this.store.post, 'featured_image')
                        }
                    ]

                }
            },
            onSuccess ({ data: post }) {
                if (!this.$isSsr) {
                    this.store.post = post
                }
            }
        }
    }
</script>
